// Fecha "en números y letras" — exigida por el HCU-117 (fecha de atención,
// ingreso/alta de hospitalización) con el mismo criterio legal que ya usa
// AM 1124 Art. 7.II.10 para la cantidad de medicamentos en la receta
// (`recetas/numeroALetras.ts`, reusado acá tal cual — mismo conversor
// entero→texto, sin duplicar la tabla de unidades/decenas/centenas).
import { numeroALetras } from './recetas/numeroALetras';

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

/** "2026-09-03" -> "tres de septiembre de dos mil veintiséis". `undefined` si la fecha es inválida/vacía. */
export function fechaEnLetras(fechaISO: string | undefined): string | undefined {
  if (!fechaISO) return undefined;
  const d = new Date(fechaISO);
  if (Number.isNaN(d.getTime())) return undefined;
  // Fechas tipo `<input type="date">` (yyyy-mm-dd, sin hora) las parsea Date
  // como UTC medianoche — usar los getters UTC evita que un huso horario
  // negativo (ej. Ecuador, UTC-5) corra el día uno hacia atrás.
  const dia = d.getUTCDate();
  const mes = MESES[d.getUTCMonth()]!;
  const anio = d.getUTCFullYear();
  return `${numeroALetras(dia)} de ${mes} de ${numeroALetras(anio)}`;
}

/** "2026-09-03" -> "03/09/2026 (tres de septiembre de dos mil veintiséis)" — formato números+letras combinado que pide el HCU-117/116. */
export function fechaNumerosYLetras(fechaISO: string | undefined): string | undefined {
  if (!fechaISO) return undefined;
  const d = new Date(fechaISO);
  if (Number.isNaN(d.getTime())) return undefined;
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const aaaa = d.getUTCFullYear();
  const letras = fechaEnLetras(fechaISO);
  return `${dd}/${mm}/${aaaa}${letras ? ` (${letras})` : ''}`;
}
